import { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { fullName } from '../../constants/personalInfo/personalInfo.ts';
import styles from './AboutMe.module.scss';

const AboutMe: FC = () => {
    const aboutMeID: string = "aboutMe";

    const { 
        t
    } = useTranslation(aboutMeID);

    return (
        <section 
            className={styles.section} 
            id={aboutMeID}
        >
            <div 
                className={styles.container}
            >
                <h2>
                    {t('greeting')}
                </h2>
                <h1>
                    {fullName}
                </h1>
                <p>
                    <Trans
                        i18nKey="summary"
                        ns={aboutMeID}
                        components={{
                            role: <span
                                className={styles.highlight}
                            />
                        }}
                    />
                </p>
                <div 
                    className={styles.description}
                >
                    <p>
                        <Trans
                            i18nKey="introduction"
                            ns={aboutMeID}
                            components={{
                                collegeFocus: <span 
                                    className={styles.highlight} 
                                />
                            }}
                        />
                    </p>
                    <p>
                        <Trans
                            i18nKey="focusBesideCollege"
                            ns={aboutMeID}
                            components={{
                                personalFocus: <span 
                                    className={styles.highlight} 
                                />
                            }}
                        />
                    </p>
                    <p>
                        <Trans
                            i18nKey="futureInterests"
                            ns={aboutMeID}
                            components={{
                                futureInterests: <span 
                                    className={styles.highlight} 
                                />
                            }}
                        />
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutMe;